const desktopBreakpoint = 1350;

const instance = ($el: HTMLElement) => {
  $el.addEventListener("click", (event: MouseEvent) => {
    let toggleClass = "toggled";
    let $targetEl = $el;

    // If a class is specified by data attribute, use that instead of default
    if ($el.hasAttribute("data-class")) {
      toggleClass = $el.getAttribute("data-class")!;
    }

    // If a target element is specified, use that instead of self
    if ($el.hasAttribute("data-target")) {
      const $specifiedTarget = document.querySelector<HTMLElement>(
        $el.getAttribute("data-target")!,
      );

      if ($specifiedTarget) {
        $targetEl = $specifiedTarget;
      }
    }

    // If double click mode is enabled, and the target element is already toggled, allow links to be clicked
    // If double click mode is disabled, and screen size is desktop, allow links to be clicked
    if (
      ($el.getAttribute("data-double-click") === "true" &&
        $targetEl.classList.contains(toggleClass)) ||
      ($el.getAttribute("data-double-click") === "false" &&
        window.innerWidth > desktopBreakpoint)
    ) {
      return true;
    }

    event.preventDefault();
    event.stopPropagation();

    // If the element has a data-untoggle attribute, untoggle the specified elements when this one is toggled
    if (
      $el.hasAttribute("data-untoggle") &&
      (!$targetEl.classList.contains(toggleClass) ||
        ($el.hasAttribute("data-untoggle-always") &&
          $el.getAttribute("data-untoggle-always") === "true"))
    ) {
      const $untoggleEls = document.querySelectorAll<HTMLElement>(
        $el.getAttribute("data-untoggle")!,
      );

      $untoggleEls.forEach(($untoggleEl) => {
        $untoggleEl.classList.remove(toggleClass);
      });
    }

    $targetEl.classList.toggle(toggleClass);

    // If the element is set to auto close and is toggled, add an event listener to close if clicked outside
    if (
      $el.hasAttribute("data-auto-close") &&
      $targetEl.classList.contains(toggleClass)
    ) {
      document.addEventListener("click", (e) => {
        if (
          !$targetEl.contains(e.target as Node) &&
          !$el.contains(e.target as Node)
        ) {
          $targetEl.classList.remove(toggleClass);
        }
      });
    } else if ($el.hasAttribute("data-auto-close")) {
      document.removeEventListener("click", () => {
        return false;
      });
    }

    return false;
  });
};

export default () => {
  const $el = document.querySelectorAll<HTMLElement>(".js-toggle-class");

  $el.forEach(($element) => {
    instance($element);
  });
};
